import { render, staticRenderFns } from "./ModalLiquidacionPersonaDetalles.vue?vue&type=template&id=529dbeee"
import script from "./ModalLiquidacionPersonaDetalles.vue?vue&type=script&lang=js"
export * from "./ModalLiquidacionPersonaDetalles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports